/**
 * Stylized Guardia Civil tricornio (three-cornered hat) emblem.
 * Custom SVG, no copyright concerns. Iconic silhouette.
 */
export function Tricornio({ className = "h-6 w-6", strokeColor = "currentColor", fillColor = "none" }) {
  return (
    <svg
      viewBox="0 0 64 40"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill={fillColor}
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinejoin="round"
      strokeLinecap="round"
      aria-hidden="true"
    >
      {/* Three corners shape */}
      <path d="M4 28 L32 8 L60 28 L52 32 L32 22 L12 32 Z" />
      {/* Lower band */}
      <path d="M10 30 Q32 36 54 30" />
      {/* Top crest dot */}
      <circle cx="32" cy="8" r="1.5" fill={strokeColor} />
    </svg>
  );
}

/**
 * Compact emblem: shield with tricornio silhouette inside.
 */
export function Emblem({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 40 40" className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id="shieldGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#0e7a48" />
          <stop offset="100%" stopColor="#053a22" />
        </linearGradient>
      </defs>
      <path
        d="M20 2 L36 8 V20 C36 28 30 35 20 38 C10 35 4 28 4 20 V8 Z"
        fill="url(#shieldGrad)"
        stroke="#d4af37"
        strokeWidth="1"
      />
      {/* Tricornio silhouette */}
      <g transform="translate(8 14)" fill="#d4af37" stroke="none">
        <path d="M0 8 L12 2 L24 8 L20 10 L12 6 L4 10 Z" />
        <path d="M2 9 Q12 13 22 9 L22 10 Q12 14 2 10 Z" />
      </g>
    </svg>
  );
}
